module.exports = __webpack_public_path__ + "img/monterey_crank.a277d1ca.png";